import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwButtonCommand, DwButtonConfig, DwModalConfig, DwModalHandler, DwModalResult } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';

@Component({
  selector: 'app-permit-request-update',
  templateUrl: './permit-request-update.component.html',
  styleUrls: ['./permit-request-update.component.scss']
})
export class PermitRequestUpdateComponent implements OnInit, DwModalHandler {

  
  modalConfig: DwModalConfig<any>;
  closeModal: EventEmitter<DwModalResult<any>>;
  request: string ="";
  
  constructor() { }
  
  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult<any>> {
    let modalResult: DwModalResult = {
      cancelled: false,
      buttonCommand: buttonConfig.command,
      closeModal: true,
    };

    switch (buttonConfig.command) {
      case DwButtonCommand.saveAndClose:
       // Just return the comments, save will happen int he action
       modalResult.data = this.request; 
       modalResult.cancelled = false;

       break;
       
      case DwButtonCommand.cancel:
        modalResult.cancelled = true;
        break;
    }

    return of(modalResult);
  }

  ngOnInit(): void {
  }

}
